const ROLE_FALLBACK = {
  REPO_ADMIN: "Repo Admin",
  TEAM_LEADER: "Team Leader",
  REPO_STAFF: "Repo Staff",
  HEAD_OFFICE_STAFF: "Head Office Staff",
  OFFICE_STAFF: "Office Staff",
  REPO_VIEWER: "Repo Viewer",
};

/** Codes like SSDIPB97BA6757 should not replace a real person name. */
export function looksLikeGeneratedUserId(value) {
  const s = String(value || "").trim();
  if (!s || /\s/.test(s)) return false;
  if (/^[0-9]{6,}$/.test(s)) return true;
  if (/^SSDI[A-Z0-9]{6,}$/i.test(s)) return true;
  if (/^[A-Z]{2,6}[A-Z0-9]{8,}$/i.test(s) && !/^[A-Z][a-z]+$/.test(s)) return true;
  return false;
}

export function displayUserName(user, roleFallback = "") {
  if (!user || typeof user === "string") {
    const raw = String(user || "").trim();
    if (raw && !looksLikeGeneratedUserId(raw)) return raw;
    return roleFallback || "User";
  }
  const candidates = [user.name, user.displayName].map((v) => String(v || "").trim());
  const proper = candidates.find((v) => v && !looksLikeGeneratedUserId(v));
  if (proper) return proper;
  return ROLE_FALLBACK[user.role] || roleFallback || "User";
}
